module.exports = __webpack_public_path__ + "img/premio-box-icon.1322969d.png";